import React, { useEffect, useState } from 'react';
import './MiniLoadingSpinner.scss';

interface MiniLoadingSpinnerProps {
    phrases?: string[] | null;
    left?: string;
    size?: 'normal' | 'small';
}

const MiniLoadingSpinner: React.FC<MiniLoadingSpinnerProps> = ({ phrases, left, size = 'normal' }) => {
    const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            if (phrases !== null && phrases !== undefined) {
    
            if (phrases?.length !== 0) {
            setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases?.length);
            }
        }
        }, 3000); // Change phrase every 3 seconds
        

        return () => clearInterval(interval); // Cleanup on unmount
    }, [phrases]);

    return (
        <div className={`mini-loading-spinner ${size}`} style={{ left: left || '50%' }}>
            <div className="shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
            </div>
            {size === 'normal' && (
            <div className="phrase">
                {(phrases?.length !== 0 && phrases !== null && phrases !== undefined) && phrases[currentPhraseIndex]}
                </div>
            )}
        </div>
    );
};

export default MiniLoadingSpinner;
